@if (visible) {
    <div
        class="m-snackbar"
        [ngClass]="{ 'is-expanded': expanded }"
        cdkDrag
    >
        <div class="m-snackbar-header" cdkDragHandle style="cursor: move">
            <div class="px-16 py-8 row align-center">
                <div class="col-3">
                    <h4>{{ "progress.all" | translate }} ({{ files.length + actions.length }})</h4>
                </div>
                <div class="col-6">
                    <m-progress-bar [value]="totalProgress" />
                </div>
                <div class="col-3">
                    <div class="flex align-center">
                        <div class="m-btn-group m-btn-group-right align-center ml-auto">
                            <a
                                class="m-btn m-btn-square"
                                (click)="toggleExpand()"
                            >
                                <app-svg-icon
                                    [fill]="hasError && !expanded ? 'red' : null"
                                    [icon]="expanded ? 'triangle-up' : 'triangle-down'"
                                >
                                </app-svg-icon>
                            </a>
                            @if (canClose()) {
                                <a
                                    class="ml-8"
                                    (click)="close()"
                                >
                                    <app-svg-icon
                                        icon="close"
                                        tooltip="{{ 'form.close' | translate }}"
                                    >
                                    </app-svg-icon>
                                </a>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        @if (expanded) {
            <div class="m-snackbar-body px-16 py-8">
                @for (file of files; track file) {
                    <div class="m-progressbar-item row align-center">
                        <span class="col-3">
                            {{ file.name }}
                        </span>
                        <div class="col-6">
                            <m-progress-bar [value]="file.progress" />
                        </div>
                        <div class="col-3">
                            <div class="flex align-center">
                                @if (!file.completed && !file.error && file === uploadFileService.currentFile) {
                                    <app-loading-spinner class="mr-8"> </app-loading-spinner>
                                }
                                @if (file.error || file.completed) {
                                    <a (click)="removeFile(file)">
                                        <app-svg-icon
                                            icon="delete"
                                            tooltip="{{ 'form.delete' | translate }}"
                                        >
                                        </app-svg-icon>
                                    </a>
                                }
                                @if (file.completed) {
                                    <app-svg-icon
                                        class="ml-8"
                                        fill="green"
                                        icon="checkmark"
                                    >
                                    </app-svg-icon>
                                }
                                @if (file.error) {
                                    <app-svg-icon
                                        class="ml-8"
                                        [tooltip]="file.errorString"
                                        fill="red"
                                        icon="error"
                                    >
                                    </app-svg-icon>
                                }
                                @if (file.error) {
                                    <a
                                        class="ml-8"
                                        (click)="retryUpload(file)"
                                    >
                                        @if (file.error) {
                                            <app-svg-icon
                                                icon="undo"
                                                tooltip="{{ 'general.retry' | translate }}"
                                            >
                                            </app-svg-icon>
                                        }
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                }
                @for (action of actions; track progressActionTrackByFn($index, action)) {
                    <div class="m-progressbar-item row align-center">
                        <span class="col-3">
                            {{ getActionLabel(action) }}
                            {{ action.lastProgress?.isPending ? "(" + ("reports.progress.pending" | translate) + ")" : "" }}
                        </span>
                        <div class="col-6">
                            <m-progress-bar [value]="action.lastProgress?.progress" />
                        </div>
                        <div class="col-3">
                            <div class="flex align-center">
                                @if (isActionWorking(action)) {
                                    <app-loading-spinner
                                        class="mr-8"
                                        tooltip="{{ action.lastProgress?.message | translate }}"
                                    >
                                    </app-loading-spinner>
                                }
                                @if (!action.lastProgress?.isDone && !action.lastProgress?.hasError) {
                                    <a (click)="cancelAction(action)">
                                        <app-svg-icon
                                            icon="cancel"
                                            tooltip="{{ 'form.cancel' | translate }}"
                                        >
                                        </app-svg-icon>
                                    </a>
                                }
                                @if (action.lastProgress?.hasError || action.lastProgress?.isDone) {
                                    <a (click)="removeAction(action)">
                                        <app-svg-icon
                                            icon="delete"
                                            tooltip="{{ 'form.delete' | translate }}"
                                        >
                                        </app-svg-icon>
                                    </a>
                                }
                                @if (action.lastProgress?.isDone) {
                                    <app-svg-icon
                                        class="ml-8"
                                        fill="green"
                                        icon="checkmark"
                                    >
                                    </app-svg-icon>
                                }
                                @if (action.lastProgress?.hasError) {
                                    <app-svg-icon
                                        class="ml-8"
                                        [tooltip]="action.lastProgress?.error | serverErrorMessage: action.lastProgress?.message : translateService.getCurrentLang() | async"
                                        fill="red"
                                        icon="error"
                                    >
                                    </app-svg-icon>
                                }
                            </div>
                        </div>
                    </div>
                }
                <div
                    class="m-anchor"
                    [innerHTML]="'reports.historyReportsMessage' | translate: { historyReportsUrl: historyReportsUrl } | safeHtml"
                ></div>
            </div>
        }
    </div>
}
